export default [
  {
    path: '/perfils',
    name: 'perfils',
    component: () => import('@/views/app/perfilAcesso/perfilAcesso-list/PerfilAcessoList.vue'),
    meta: {
      pageTitle: 'Perfil Acesso',
      resource: 'AdminHanes',
    },
  },
  {
    path: '/apps/perfilAcesso/edit/:id',
    name: 'apps-perfil-edit',
    component: () => import('@/views/app/perfilAcesso/perfilAcesso-edit/PerfilAcessoEdit.vue'),
    meta: {
      pageTitle: 'Editar Perfil',
      resource: 'AdminHanes',
    },
  },
];
